import React, { useState } from 'react';
import { assignJourney } from '../api';
import { useToast } from '../../../hooks/useToast';
import TripPicker, { TripOption, TripChoice } from './TripPicker';

// Unsorted-page wrapper: renders the shared TripPicker in action mode and fires
// the assignment immediately on selection. The visual control comes from
// TripPicker so it matches the planner's "Add to trip" picker.

export type { TripOption };

export interface AssignDropdownProps {
  journeyId: string;
  trips: TripOption[];
  onAssigned: () => void;
  /** Pre-fill the "Create new trip" prompt (e.g. the journey's name). */
  newTripDefaultName?: string;
}

const AssignDropdown: React.FC<AssignDropdownProps> = ({ journeyId, trips, onAssigned, newTripDefaultName }) => {
  const { showToast } = useToast();
  const [busy, setBusy] = useState(false);

  const handleSelect = async (choice: TripChoice) => {
    setBusy(true);
    try {
      await assignJourney(journeyId, choice);
      showToast({ title: 'Filed', message: 'Journey assigned to the trip.', type: 'success' });
      onAssigned();
    } catch (e: any) {
      const msg = e?.response?.data?.error || e.message || 'Failed to assign journey';
      showToast({ title: 'Error', message: msg, type: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <TripPicker
      trips={trips}
      includeCreateNew
      newTripDefaultName={newTripDefaultName}
      disabled={busy}
      firstOptionLabel={busy ? 'Assigning…' : 'Assign to a trip…'}
      onSelect={handleSelect}
    />
  );
};

export default AssignDropdown;
